import * as moment from 'moment';

export function getWeeksInMonth(startDate: number | moment.Moment | Date) {
    const fistDayOfMonth = moment(startDate).startOf('month');
    const curMonth = fistDayOfMonth.month();

    const weeks = [];
    let reachEndOfMonth = false;
    let weekNumber = 0;

    while (!reachEndOfMonth) {
        const curDay = moment(fistDayOfMonth).add(weekNumber * 7, 'days');
        const week = {
            start: moment(curDay).startOf('isoWeek'),
            end: moment(curDay).endOf('isoWeek'),
        };

        if (week.end.month() === curMonth ||
            (week.end.month() > curMonth && week.start.month() === curMonth)) {
            weeks.push(week);
            weekNumber = weekNumber + 1;
        } else {
            reachEndOfMonth = true;
        }
        if ((week.end.month() === 0 && curMonth === 11 && weeks.length > 0 && weeks[weeks.length - 1].end.date() < 31)) {
            weeks.push(week);
        }
    }
    return weeks;
}
